import { makeStyles } from "@material-ui/core";

export const addContactV2Style = makeStyles((theme) => ({
  formLabel: {
    fontWeight: "600 !important",
    color: "#181f48",
    marginBottom: "0px !important",
  },

  drawerBodyWrapper: {
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
        width: "6px",
    },
    "&::-webkit-scrollbar-track": {
        borderRadius: "10px",
        backgroundColor: "#2c3e50",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#346fef",
        borderRadius: "10px",
    },
  },

  sidebarWrapper: {
    width: "160px !important" ,
    padding: "8px",
  },
  sidebarList: {
    "& .Mui-selected": {
      backgroundColor: "#3e50f7 !important",
      color: "white",
      borderRadius: 8,
      "&:hover":{
        backgroundColor: "#3e50f7 !important",
        color: "white",
        borderRadius: 8,
      },
      "& .MuiTypography-root": {
        fontWeight: 600,
      },
    },
    "& .MuiListItem-button:hover": {
      borderRadius: theme.spacing(1),
    },
    "& .MuiListItem-gutters": {
      padding: "4px 8px",
    },
    "& .MuiListItemIcon-root": {
      minWidth: 30,
      justifyContent: "flex-start",
    },
    "& .MuiListItemText-root": {
      minWidth: 110,
      display: "block",
      width: '130px !important'
    },
    "& .MuiListItemSecondaryAction-root": {
      display: "block",
      right: 8,
    },
  },

  sideBarButton: {
    marginBottom: '4px !important', 
    width:'140px !important', 
    display:'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: '4px 14px !important'
  },

  addButtonStyle: {
    backgroundColor: "#3e50f7 !important",
    borderRadius: "4px",
    height: "37px",
    width: "37px",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
    color: "white !important",
  },

  manualEntryButton: {
    backgroundColor: "#3e50f7 !important",
    color: "white !important",
    marginBottom: "10px",
    fontWeight: "700px",
    "&:hover,&:focus": {
      backgroundColor: "#3e50f7 !important",
      color: "white !important",
      opacity: 0.8,
    },
  },

  titleStyle: {
    fontSize: '18px !important',
    fontWeight: "600 !important",
    color: "var(--dark_blue) !important",
    whiteSpace: "nowrap",
    height: 'unset !important'
  },

  googlePlacesAutocomplete: {
    width: "100%",
    marginTop: theme.spacing(2),
    "& .my-google-places-autocomplete__menu": {
      zIndex: 2,
    },
    "& .my-google-places-autocomplete__value-container": {
      padding: "0px 8px",
    },
    "& .my-google-places-autocomplete__input": {
      height: "16px !important",
      textAlign: "left !important",
      margin: "0 !important",
      border: "none !important",
      outline: "none !important",
      boxShadow: "none !important",
    },
    "& .my-google-places-autocomplete__input:focus": {
      border: "none !important",
      outline: "none !important",
      boxShadow: "none !important",
    },
    "& .my-google-places-autocomplete__control": {
      fontSize: "15px !important",
    },
    "& .my-google-places-autocomplete__input input": {
      height: "unset !important",
    },
  },

  cancelButton: {
    borderRadius: '6px !important',
    backgroundColor: "#transparent !important",
    fontWeight: "600",
    width: "120px !important",
    textTransform: "capitalize",
    border: "1px solid rgba(0, 0, 0, 0.23) !important",
    color: "#000 !important",
    "&:hover,&:focus": {
      backgroundColor: "transparent !important",
    },
    
  },

  submitButton: {
    backgroundColor: "#3e50f7 !important",
    color: "#fff !important",
    fontWeight: "600",
    width: "120px !important",
    textTransform: "capitalize",
    "&:hover,&:focus": {
      backgroundColor: "#3e50f7 !important",
      color: "#fff !important",
    },
  },

    addButton: {
    backgroundColor: "#3e50f7 !important",
    color: "#fff !important",
    fontWeight: "600",
    width: "75px !important",
    textTransform: "capitalize",
    "&:hover,&:focus": {
      backgroundColor: "#3e50f7 !important",
      color: "#fff !important",
    },
  },

  headlineWrapper: {
    color: "#3C7EF3",
    backgroundColor: "#e8f0fe",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "10px 16px",
    borderRadius: "5px",
    marginBottom: "4px",
    border: "1px solid #3C7EF3",

    "& .MuiDivider-root": {
      color: "white",
      backgroundColor: "white",
    },
  },
}));

export const drawerHeaderStyle = makeStyles((theme) => ({
  headerWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "2px solid var(--gray_dark)",
    padding: "8px 20px",
    marginBottom: "16px",
  },

  titleContainer: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "start",
  },

  drawerTitle: {
    fontFamily: "var(--poppins)",
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: 500,
    margin: 0,
  },

  headerButton: {
    width: '106px !important',
    borderRadius: "50px !important",
    textTransform: "capitalize",
    fontWeight: 600,
    paddingInline: "16px !important",

    "&.MuiButton-contained": {
      backgroundColor: "#3e50f7 !important",
      color: "#ffffff !important",
      "&:hover,&:focus": {
        backgroundColor: "#3e50f7 !important",
        color: "#ffffff !important",
      },
    },

    "&.MuiButton-outlined": {
      backgroundColor: "transparent !important",
      border: "1px solid rgba(0, 0, 0, 0.23)",
      color: "#000 !important",
      "&:hover,&:focus": {
        backgroundColor: "transparent !important",
        color: "#000 !important",
      },
    },
  },
}));
